import { Box, makeStyles } from '@material-ui/core';
import { Fragment } from 'react';
import {
  TERMINAL_BATTERY,
  TERMINAL_TEAM_LOGO,
  TERMINAL_LINK,
} from 'utils/constants';

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: '10%',
    clipPath: `url(#clip-path)`,
    overflow: 'hidden',
  },
});

const ScreenFrame = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {children ? (
        <Fragment>
          <img src={TERMINAL_LINK} height={12} />
          {children}
          <img src={TERMINAL_BATTERY} height={12} />
        </Fragment>
      ) : (
        <Fragment>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            height="100%"
          >
            <img src={TERMINAL_TEAM_LOGO} width="100%" />
          </Box>
        </Fragment>
      )}
    </div>
  );
};

export default ScreenFrame;
